import { useQuery } from '@tanstack/react-query'

import { useLegacyAuthApi } from '@/services/api/ApiContext'

export const URL = 'vehicleEvents/tables/{groupName}'

export const VEHICLE_EVENTS_GROUPS = {
  vehicleEventStatuses: 'vehicleeventstatuses',
  vehicleEventItemStatuses: 'vehicleeventitemstatuses',
  repairHandlerTypes: 'repairhandlertypes',
  inspectors: 'inspectors',
  referents: 'referents',
  rescheduleReasons: 'reschedulereasons',
  cancelReasons: 'cancelreasons',
}

const useGetVehicleEventsTable = (
  groupName,
  config = {},
  {
    query,
    pageSize = 500,
    pageNumber = 1,
    sortDirection,
    orderBy,
  } = {},
) => {
  const api = useLegacyAuthApi()
  return useQuery({
    queryKey: ['get-vehicle-events-table-group', groupName, query, pageSize, pageNumber, sortDirection, orderBy],
    queryFn: async () => {
      if (!api || !groupName) {
        return false
      }
      const params = Object.fromEntries(
        Object.entries({ query, pageSize, pageNumber, sortDirection, orderBy })
          .filter(([, v]) => v !== undefined),
      )
      const { data } = await api.get(URL.replace('{groupName}', groupName), { params })
      return data
    },
    staleTime: Infinity,
    ...config,
  })
}

export default useGetVehicleEventsTable
